<template>
    <div class="flex items-center justify-between gap-5">
        <div class="flex items-center bg-[#e6e4e0] rounded-xl px-4 py-0.5">
            <button @click.prevent="decrement"
                    class="flex items-center justify-center w-6 h-6 text-lg font-medium text-gray-700 md:hover:bg-gray-200 rounded-full transition">
                <IconMinus class="w-3 h-3"/>
            </button>
            <input type="number" :value="localQty"
                   @input="onInput($event)" @blur="onBlur"
                   :step="step" :min="step"
                   class="w-20 text-center mx-2 border-0 bg-transparent focus:ring-0 focus:border-0 text-sm"/>
            <button @click.prevent="increment"
                    class="flex items-center justify-center w-6 h-6 text-lg font-medium text-gray-700 md:hover:bg-gray-200 rounded-full transition">
                <IconPlus class="w-3 h-3"/>
            </button>
        </div>
        <select v-model="unit"
                class="py-2.5 px-0 text-sm font-medium text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 peer">
            <option value="m2">м²</option>
            <option value="piece">шт.</option>
            <option v-if="countInBox > 0" value="box">упак.</option>
        </select>
    </div>
</template>

<script>
import IconMinus from "@js/components/Icons/IconMinus.vue";
import IconPlus from "@js/components/Icons/IconPlus.vue";
import {useCartStore} from "@js/store/CartStore.js";

export default {
    name: 'QuantitySelector',
    components: {IconPlus, IconMinus},
    props: {
        productId: {type: [String, Number], required: true},
        modelValue: {
            type: Number,
            default: 1
        },
        modelUnit: {
            type: String,
            default: 'm2'
        },
        /** Площадь одной плитки в м² */
        areaPerPiece: {
            type: Number,
            default: 1
        },
        /** Количество штук в коробке */
        countInBox: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            localQty: this.modelValue,
            unit: this.modelUnit,
            cartProduct: null,
        };
    },
    created() {
        this.getProductFromCart();
        if (this.cartProduct) {
            this.localQty = this.cartProduct.qty;
            this.unit = this.cartProduct.unit;
            this.$emit('update:modelValue', this.localQty);
            this.$emit('update:modelUnit', this.unit);
        }
    },
    computed: {
        /** Шаг изменения: площадь, 1 шт или размер коробки */
        step() {
            const area = parseFloat(this.areaPerPiece);
            if (this.unit === 'm2' && !isNaN(area) && area > 0) return area;
            if (this.unit === 'box' && this.countInBox > 0) return this.countInBox;
            return 1;
        }
    },
    methods: {
        getProductFromCart() {
            this.cartProduct = this.cartStore.findItem(this.productId)
        },
        increment() {
            this.localQty = parseFloat((this.localQty + this.step).toFixed(2));
            this.emitChange();

            if (this.cartProduct) {
                this.cartStore.updateQty(this.cartProduct.id, this.unit, this.localQty)
            }
        },
        decrement() {
            if (this.unit === 'm2') {
                const newVal = parseFloat((this.localQty - this.step).toFixed(2));
                if (newVal >= this.step) this.localQty = newVal;
            } else if (this.unit === 'box' && this.countInBox > 0) {
                if (this.localQty > this.countInBox) this.localQty -= this.countInBox;
            } else {
                if (this.localQty > 1) this.localQty -= 1;
            }
            this.emitChange();

            if (this.cartProduct) {
                this.cartStore.updateQty(this.cartProduct.id, this.unit, this.localQty)
            }
        },
        onInput(e) {
            let val = parseFloat(e.target.value);
            if (isNaN(val) || val <= 0) val = this.step;
            this.localQty = val;
            this.emitChange();
        },
        onBlur() {
            let val = this.localQty;
            if (this.unit === 'm2') {
                const pieces = Math.ceil(val / this.areaPerPiece);
                this.localQty = parseFloat((pieces * this.areaPerPiece).toFixed(2));
            } else if (this.unit === 'box' && this.countInBox > 0) {
                const boxes = Math.ceil(val / this.countInBox);
                this.localQty = boxes * this.countInBox;
            } else {
                this.localQty = Math.ceil(val);
            }

            if (this.cartProduct) {
                this.cartStore.updateQty(this.cartProduct.id, this.unit, this.localQty)
            }

            this.emitChange();
        },
        emitChange() {
            this.$emit('update:value', this.localQty);
            this.$emit('update:unit', this.unit);
        }
    },
    watch: {
        modelValue(v) {
            this.localQty = v;
        },
        modelUnit(u) {
            this.unit = u;
        },
        unit() {
            this.localQty = this.step;
            this.emitChange();
        }
    },
    setup() {
        const cartStore = useCartStore();
        return {cartStore}
    }
};
</script>
